import {ChevronRight} from "lucide-react";

// A single playlist as a horizontal, swipeable row of cards (Netflix-style).
//
// Rows preview at most `previewLimit` cards so a 200-video playlist doesn't
// mount 200 thumbnails. The header shows the true count and a "See all"
// button that opens the caller's full playlist view via `onSeeAll`.
const PlaylistRow = ({
  title,
  videos,
  renderCard,
  previewLimit = 12,
  onSeeAll,
}) => {
  if (!videos || videos.length === 0) return null;
  const shown = videos.slice(0, previewLimit);
  const hasMore = videos.length > shown.length;

  return (
    <section className="mb-4">
      <div className="flex items-center justify-between gap-3 mb-2 px-1">
        <h3 className="text-base font-semibold text-[#262626] tracking-tight truncate">
          {title}
          <span className="ml-2 text-xs font-medium text-[#262626]/40">
            {videos.length} {videos.length === 1 ? "video" : "videos"}
          </span>
        </h3>
        {(hasMore || onSeeAll) && (
          <button
            type="button"
            onClick={onSeeAll}
            disabled={!onSeeAll}
            aria-label={`See all videos in ${title}`}
            className="flex items-center gap-0.5 text-xs font-semibold text-[#001489] shrink-0 disabled:text-[#262626]/40 disabled:cursor-default"
          >
            See all
            <ChevronRight size={14} />
          </button>
        )}
      </div>

      <div className="flex gap-4 overflow-x-auto pb-2 -mx-1 px-1 snap-x [scrollbar-width:thin]">
        {shown.map((v) => (
          <div key={v.id} className="shrink-0 w-60 sm:w-64 snap-start">
            {renderCard(v)}
          </div>
        ))}
      </div>
    </section>
  );
};

export default PlaylistRow;
